import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import * as moment from 'moment';
import { animations } from '@app/shared/calendar/calendar.animations';

interface Date {
  date: moment.Moment;
  isSelectedMonth: boolean;
}

interface DateRange {
  start: moment.Moment;
  end: moment.Moment;
}

interface SelectedWeek {
  index: number;
  date: moment.Moment;
}


@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
  animations: animations,
})
export class CalendarComponent implements OnInit, OnChanges {
  currentDate = moment();
  weeks: Date[][];
  weekadays = moment.weekdaysShort(true);
  selectedWeek: SelectedWeek = { index: null, date: this.currentDate };
  selectedDate: moment.Moment;
  selectedMonth = this.currentDate;
  events = {};
  animationState: string;

  @Output() onDateSelect = new EventEmitter<DateRange>();
  @Output() onMothChanged = new EventEmitter<moment.Moment>();
  @Input() calendarEvents: Object;

  constructor() { }

  ngOnInit() {
    this.generate();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.calendarEvents) {
      this.events = changes.calendarEvents.currentValue;
    }
  }

  prev() {
    if (this.currentDate.month() === 0) {
      this.currentDate = moment(this.currentDate).add(11, 'months');
    } else {
      this.currentDate = moment(this.currentDate).subtract(1, 'months');
    }
    this.generate();
    this.onMothChanged.emit(this.currentDate);
    this.animationState = 'prev';
  }

  next() {
    if (this.currentDate.month() === 11) {
      this.currentDate = moment(this.currentDate).subtract(11, 'months');
    } else {
      this.currentDate = moment(this.currentDate).add(1, 'months');
    }
    this.generate();
    this.onMothChanged.emit(this.currentDate);
    this.animationState = 'next';
  }

  isSelectedMonth(date: moment.Moment): boolean {
    return moment(date).isSame(this.currentDate, 'month');
  }

  selectDate(start: moment.Moment) {
    this.selectedDate = this.selectedDate === start ? null : start;
    this.selectedMonth = null;
    this.selectedWeek = {
      index: null,
      date: this.currentDate
    };
    this.emitDateChange();
  }

  selectWeek(index: number) {
    this.selectedDate = null;
    this.selectedMonth = null;
    this.selectedWeek = {
      index: this.selectedWeek.index === index ? null : index,
      date: this.currentDate
    };

    this.emitDateChange();
  }

  selectMonth() {
    this.selectedDate = null;
    this.selectedWeek = {
      index: null,
      date: this.currentDate
    };
    this.selectedMonth = this.currentDate;
    this.emitDateChange();
  }

  emitDateChange() {
    if (this.selectedDate) {
      return this.onDateSelect.emit({ start: this.selectedDate, end: this.selectedDate });
    }
    if (this.selectedWeek.index !== null) {
      return this.onDateSelect.emit({
        start: this.weeks[this.selectedWeek.index][0].date,
        end: this.weeks[this.selectedWeek.index][6].date
      });
    }
    const start = moment(this.currentDate).startOf('month');
    const end = moment(this.currentDate).endOf('month');
    return this.onDateSelect.emit({ start: start, end: end });
  }

  hasEvents(date: moment.Moment) {
    const key = date.format('YYYY-MM-DD');
    return (this.events[key] && this.events[key] > 0);
  }

  weekHasEvents(week) {
    let res = false;
    week.forEach(item => {
      res = res || this.hasEvents(item.date);
    });
    return res;
  }

  generate() {
    const dates = this.getDates(this.currentDate);
    const weeks: Date[][] = [];
    while (dates.length > 0) {
      weeks.push(dates.splice(0, 7));
    }
    this.weeks = weeks;
  }

  getDates(date: moment.Moment): Date[] {
    const firstDayOfMonth = moment(date).startOf('month');
    const startDay = moment(date).startOf('month').subtract(firstDayOfMonth.day(), 'days');
    const startDate = startDay.date();
    const dates: Date[] = [];

    for (let i = startDate + 1; i <= startDate + 42; i++) {
      const d = moment(startDay).date(i);
      if (moment(d).isAfter(this.currentDate, 'month') && d.day() === 1 ) break;
      dates.push({
        date: d,
        isSelectedMonth: this.isSelectedMonth(d),
      });
    }
    return dates;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/calendar/calendar.component.ts